import { ws } from "../../utils/common";

export const getLogsWS = async ({ start, end }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "log/",
    {
      start: start && end ? start : null,
      end: start && end ? end : null,
      limit: 1000,
    },
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
